import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import { LoaderProvider } from './context/LoaderContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Toaster />
      {/* <Toaster
        toastOptions={{ 
          className: "font-medium rounded-xl",
          success: {
            className: "text-xl font-poppins",
          },
          error: {
            className: "text-xl font-poppins",
          },
        }}
      /> */}
      <LoaderProvider>
        <RouterProvider router={router} />
      </LoaderProvider>
    </ThemeProvider>
  );
}

export default App;
